import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { memo, useContext } from 'react';
import css from './CompareOverlay.module.scss';
import HouseAd from '../HouseAd';
import { OVContext } from '../../utils/OVContext';
import Overlay from '../Ovly';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var CompareOverlay = function CompareOverlay(_ref) {
  var linkText = _ref.linkText,
      compareAds = _ref.compareAds,
      compareAttributes = _ref.compareAttributes,
      small = _ref.small;

  var _useContext = useContext(OVContext),
      mobileLarge = _useContext.mobileLarge;

  return /*#__PURE__*/_jsx(Overlay, {
    ariaLabelledBy: "compare-overlay-title",
    button: /*#__PURE__*/_jsx("div", {
      className: cc([css.button, _defineProperty({}, css.small, small)]),
      children: linkText
    }),
    label: linkText.toLowerCase(),
    noPadding: true,
    wide: true,
    children: /*#__PURE__*/_jsxs("div", {
      className: css.body,
      children: [/*#__PURE__*/_jsx("header", {
        className: css.title,
        id: "compare-overlay-title",
        children: linkText
      }), /*#__PURE__*/_jsxs("div", {
        className: cc([css.wrapper, _defineProperty({}, css.text, compareAttributes)]),
        children: [compareAds && compareAds.map(function (ad) {
          return /*#__PURE__*/_jsx("div", {
            className: css.ad,
            children: /*#__PURE__*/_jsx(HouseAd, _objectSpread(_objectSpread({}, ad), {}, {
              isMobile: mobileLarge,
              noPadding: true,
              wide: true
            }))
          }, ad.id);
        }), compareAttributes && compareAttributes.map(function (attributes, idx) {
          return /*#__PURE__*/_jsxs("div", {
            className: css.attributes,
            children: [/*#__PURE__*/_jsx("h3", {
              className: css.fabric,
              children: attributes.title
            }), /*#__PURE__*/_jsx("div", {
              dangerouslySetInnerHTML: {
                __html: attributes.attributes
              }
            })]
          }, "attributes-".concat(idx));
        })]
      })]
    })
  });
};

CompareOverlay.defaultProps = {
  compareAds: null,
  compareAttributes: null,
  small: false
};
CompareOverlay.propTypes = {
  compareAds: PropTypes.array,
  compareAttributes: PropTypes.array,
  linkText: PropTypes.string.isRequired,
  small: PropTypes.bool
};
export default /*#__PURE__*/memo(CompareOverlay);